import React from "react";
import styles from "./styles.module.scss";
import { AvatarGroupProps } from "./types";

export default function AvatarGroup({
    images = [],
    maxCount = 3,
    containerClassName = "",
}: AvatarGroupProps) {
    const visibleImages = images.slice(0, maxCount);
    const hiddenCount = images.length - visibleImages.length;

    return (
        <div className={`${styles.container} ${containerClassName}`}>
            {visibleImages.map((img, index) => (
                <div 
                    key={index} 
                    className={styles.avatar}
                    style={{ zIndex: visibleImages.length - index }}
                >
                    <img src={img} alt={`Avatar ${index + 1}`} />
                </div>
            ))}
            {hiddenCount > 0 && (
                <div className={styles.overflowAvatar} style={{ zIndex: 0 }}>
                    +{hiddenCount}
                </div>
            )}
        </div>
    );
}
